export const START_PHOTO_SESSION = 'START_PHOTO_SESSION';
export const CHECKLIST_MAIN_PAGE_VIEWED_ANALYTICS = 'CHECKLIST_MAIN_PAGE_VIEWED_ANALYTICS';
export const CHECKLIST_HOUSE_STEP_CLICKED_ANALYTICS = 'CHECKLIST_HOUSE_STEP_CLICKED_ANALYTICS';
export const CHECKLIST_EXTERNAL_AREA_CLICKED_ANALYTICS = 'CHECKLIST_EXTERNAL_AREA_CLICKED_ANALYTICS';
export const CHECKLIST_GENERAL_CONDITIONS_CLICKED_ANALYTICS = 'CHECKLIST_GENERAL_CONDITIONS_CLICKED_ANALYTICS';
export const CHECKLIST_ITEM_CHANGED = 'CHECKLIST_ITEM_CHANGED';
export const UPDATE_STORAGE_CHECKLIST_ITEM = 'UPDATE_STORAGE_CHECKLIST_ITEM';
export const UPDATE_HOUSE_ADDRESS = 'UPDATE_HOUSE_ADDRESS';
export const FETCH_API_CHECKLIST_ITEMS = 'FETCH_API_CHECKLIST_ITEMS';
export const FETCH_CHECKLIST_FROM_STORAGE = 'FETCH_CHECKLIST_FROM_STORAGE';
export const FINISH_CHECKLIST_ACTION = 'FINISH_CHECKLIST_ACTION';
export const FINISH_CHECKLIST_CLICKED_ANALYTICS = 'FINISH_CHECKLIST_CLICKED_ANALYTICS';
export const FINISH_CHECKLIST_ERROR_UPDATE = 'FINISH_CHECKLIST_ERROR_UPDATE';
export const CHECKLIST_CLEAN_STORE = 'CHECKLIST_CLEAN_STORE';
export const CHECKLIST_VALID_CHANGED = 'CHECKLIST_VALID_CHANGED';
export const CHECKLIST_OPEN_DIALOG_CHANGED = 'CHECKLIST_OPEN_DIALOG_CHANGED';
export const OPEN_FINISH_SESSION_DIALOG = 'OPEN_FINISH_SESSION_DIALOG';
export const UPDATE_CONDO_NAME = 'UPDATE_CONDO_NAME';
